import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { GetBiographyUsecase } from './GetBiographyUseCase';
import { GetEpisodesUseCase } from './GetEpisodesUseCase';
import { GetFeedUseCase } from './GetFeedUseCase';
import { GetMoviesUseCase } from './GetMoviesUseCase';
import { GetProductsUseCase } from './GetProductsUseCase';
import { GetSeriesUseCase } from './GetSeriesUseCase';
import { GetMpxAllAssetsUseCase } from './GetMpxAllAssetsUseCase';
import { GetMpxCastCrewUseCase } from './GetMpxCastCrewUseCase';
import { GetSeasonsUseCase } from './GetSeasonsUseCase';
import { GetFilmographyUsecase } from './GetFilmographyUseCase';
import { GetChannelCategoriesUseCase } from './GetChannelCategoriesUseCase';
import { GetChannelListByCategoryUseCase } from './GetChannelListByCategoryUseCase';
import { GetCatchUpEpisodesUseCase } from './GetCatchUpEpisodesUseCase';
import { GetCatchUpEpisodeDetailUseCase } from './GetCatchUpEpisodeDetailUseCase';
import { GetPPVFeedUseCase } from './GetPPVFeedUseCase';
import { GetMixedCatchUpEpisodesUseCase } from './GetMixedCatchUpEpisodesUseCase';
import { GetContentDetailsUseCase } from './GetContentDetailsUseCase';

export const initializeMpxUseCases = (container: Container) => {
    container.register(DI.USECASES.IGetBiographyUseCase, {
        useClass: GetBiographyUsecase,
    });
    container.register(DI.USECASES.IGetFilmographyUseCase, {
        useClass: GetFilmographyUsecase,
    });
    container.register(DI.USECASES.IGetEpisodesUseCase, {
        useClass: GetEpisodesUseCase,
    });
    container.register(DI.USECASES.IGetFeedUseCase, {
        useClass: GetFeedUseCase,
    });
    container.register(DI.USECASES.IGetMoviesUseCase, {
        useClass: GetMoviesUseCase,
    });
    container.register(DI.USECASES.IGetProductsUseCase, {
        useClass: GetProductsUseCase,
    });
    container.register(DI.USECASES.IGetSeriesUseCase, {
        useClass: GetSeriesUseCase,
    });
    container.register(DI.USECASES.IGetMpxAllAssetsUseCase, {
        useClass: GetMpxAllAssetsUseCase,
    });
    container.register(DI.USECASES.IGetMpxCastCrewUseCase, {
        useClass: GetMpxCastCrewUseCase,
    });
    container.register(DI.USECASES.IGetSeasonsUseCase, {
        useClass: GetSeasonsUseCase,
    });
    container.register(DI.USECASES.IGetChannelCategoriesUseCase, {
        useClass: GetChannelCategoriesUseCase,
    });
    container.register(DI.USECASES.IGetChannelListByCategoryUseCase, {
        useClass: GetChannelListByCategoryUseCase,
    });
    container.register(DI.USECASES.IGetCatchUpEpisodesUseCase, {
        useClass: GetCatchUpEpisodesUseCase,
    });
    container.register(DI.USECASES.IGetMixedCatchUpEpisodesUseCase, {
        useClass: GetMixedCatchUpEpisodesUseCase,
    });
    container.register(DI.USECASES.IGetCatchUpEpisodeDetailUseCase, {
        useClass: GetCatchUpEpisodeDetailUseCase,
    });
    container.register(DI.USECASES.IGetPPVFeedUseCase, {
        useClass: GetPPVFeedUseCase,
    });
    container.register(DI.USECASES.IGetContentDetailsUseCase, {
        useClass: GetContentDetailsUseCase,
    });
};
